package com.solevo.dist.network.firebase.api.orders.models

import com.solevo.dist.application.models.DeliveryNote
import com.solevo.dist.application.models.DeliveryNoteLine
import com.solevo.dist.application.models.DocMetadata
import com.solevo.dist.application.models.Order
import com.solevo.dist.application.models.OrderLine
import com.solevo.dist.application.models.OrderType
import com.solevo.dist.network.implementation.firebase.utils.time.toKotlinInstant
import dev.gitlive.firebase.firestore.Timestamp
import kotlinx.serialization.Serializable

enum class FirebaseOrderStatus {
    Initialized,
    Created,
    Confirmed,
    Expired,
    Cancelled,
    Closed,
    Error
}

@Serializable
data class FirebaseOrder(
    val orderId: String = "",
    val totalAmount: Double = 0.0,
    val totalRemainingAmount: Double? = 0.0,
    val status: FirebaseOrderStatus = FirebaseOrderStatus.Created,
    val orderDate: Timestamp = Timestamp.now(),
    val deliveryNotes: List<FirebaseDeliveryNote>? = null,
    val orderLines: List<OrderLine>? = null,
    val customerId: String = "",
    val orderReference: String? = null,
    val pickupDateFrom: Timestamp? = Timestamp.now(),
    val pickupDateTo: Timestamp? = Timestamp.now(),
    val errorText: String? = null,
    val errorCode: String? = null,
    var appOrder: Boolean? = null,
    var legalEntityId: String? = null,
    var requestedShipDate: Timestamp? = Timestamp.now(),
    var orderType: OrderType = OrderType.SalesAgreement
)

@Serializable
data class FirebaseDeliveryNote(
    val id: String = "",
    val unit: String? = null,
    val pickedItems: List<DeliveryNoteLine>? = null,
    val docMetadata: DocMetadata? = null,
    val pickingDate: Timestamp? = null,
)

fun FirebaseOrder.toOrder(): Order {
    return Order(
        orderId = orderId,
        totalAmount = totalAmount,
        totalRemainingAmount = totalRemainingAmount,
        status = status.toOrderStatus(),
        orderDate = orderDate.toKotlinInstant(),
        deliveryNotes = deliveryNotes?.map { it.toDeliveryNote() },
        orderLines = orderLines,
        customerId = customerId,
        orderReference = orderReference,
        pickupDateFrom = pickupDateFrom?.toKotlinInstant(),
        pickupDateTo = pickupDateTo?.toKotlinInstant(),
        errorText = errorText,
        errorCode = errorCode,
        appOrder = appOrder,
        legalEntityId = legalEntityId,
        requestedShipDate = requestedShipDate?.toKotlinInstant(),
        orderType = orderType
    )
}

private fun FirebaseOrderStatus.toOrderStatus(): Order.Status {
    return when (this) {
        FirebaseOrderStatus.Initialized -> Order.Status.Initialized
        FirebaseOrderStatus.Created -> Order.Status.Created
        FirebaseOrderStatus.Confirmed -> Order.Status.Confirmed
        FirebaseOrderStatus.Expired -> Order.Status.Expired
        FirebaseOrderStatus.Cancelled -> Order.Status.Cancelled
        FirebaseOrderStatus.Closed -> Order.Status.Closed
        FirebaseOrderStatus.Error -> Order.Status.Error
    }
}

fun FirebaseDeliveryNote.toDeliveryNote(): DeliveryNote {
    return DeliveryNote(
        id = id,
        unit = unit,
        pickedItems = pickedItems,
        docMetadata = docMetadata,
        pickingDate = pickingDate?.toKotlinInstant()
    )
}
